import { CollectionId } from "@genai/collection";

export enum FileStatus {
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
}

export type Tags = {
  brand: string;
  range: string;
}

export type FileId = string & {
  readonly __brand_file__: unique symbol;
};

export type Brand = {
  name: string;
  models: string[];
}

export interface StoredFile {
  uuid: FileId;
  brand: string;
  chunkingStrategy: string;
  collection: CollectionId;
  fileType: string;
  models: string[];
  name: string;
  status: FileStatus;
  statusDatetime: string;
  tags: Tags[];
}
